import { all } from 'redux-saga/effects';

import consultaInteracoes from './consultaInteracoes/saga';
import enviaInteracoes from './enviaInteracoes/saga';
import enviaRespostas from './enviaRespostas/saga';

export default all([consultaInteracoes, enviaInteracoes, enviaRespostas]);
